import i18n from '../../i18n';

const du = (key, opts) => i18n.t(`modules.shared.aiAgent.documentUpload.${key}`, opts);

export const DOCUMENT_ATTACHMENT_ACCEPT =
  'image/jpeg,image/png,image/webp,image/gif,application/pdf,.pdf';
export const DOCUMENT_ATTACHMENT_MAX_BYTES = 12 * 1024 * 1024;

const ALLOWED_MIME_TYPES = new Set([
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
  'application/pdf',
]);

function guessMimeType(file) {
  if (file.type) return file.type;
  const lower = file.name.toLowerCase();
  if (lower.endsWith('.pdf')) return 'application/pdf';
  if (lower.endsWith('.png')) return 'image/png';
  if (lower.endsWith('.webp')) return 'image/webp';
  if (lower.endsWith('.gif')) return 'image/gif';
  if (lower.endsWith('.jpg') || lower.endsWith('.jpeg')) return 'image/jpeg';
  return '';
}

export function isPdfAttachment(file) {
  return guessMimeType(file) === 'application/pdf';
}

export function validateDocumentAttachmentFile(file) {
  if (!file) return du('no_file_selected');

  const mime = guessMimeType(file);
  if (!ALLOWED_MIME_TYPES.has(mime)) {
    return du('unsupported_format');
  }

  if (file.size > DOCUMENT_ATTACHMENT_MAX_BYTES) {
    return du('file_too_large');
  }

  return null;
}

export function createAttachmentPreview(file) {
  const isPdf = isPdfAttachment(file);
  return {
    file,
    kind: isPdf ? 'pdf' : 'image',
    previewUrl: isPdf ? null : URL.createObjectURL(file),
    name: file.name,
    mimeType: guessMimeType(file),
  };
}

export function revokeAttachmentPreview(attachment) {
  if (attachment?.previewUrl) {
    URL.revokeObjectURL(attachment.previewUrl);
  }
}

/** @deprecated use DOCUMENT_ATTACHMENT_ACCEPT */
export const DOCUMENT_IMAGE_ACCEPT = DOCUMENT_ATTACHMENT_ACCEPT;

/** @deprecated */
export function validateDocumentImageFile(file) {
  return validateDocumentAttachmentFile(file);
}
